import { lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import { ToastProvider } from "./components/Toaster";
import PageMeta from "./components/PageMeta";
import RouteLoading from "./components/PageLoader";

const Blogs = lazy(() => import("./pages/Blogs"));
const SingleBlog = lazy(() => import("./pages/SingleBlog"));
const StoreLocator = lazy(() => import("./pages/StoreLocator"));
const Catalog = lazy(() => import("./pages/Catalog"));
const ProductPage = lazy(() => import("./pages/ProductPage"));
const FAQ = lazy(() => import("./pages/faq"));
const Contact = lazy(() => import("./pages/Contact"));
const Impact = lazy(() => import("./pages/Impact"));
const Story = lazy(() => import("./pages/Story"));
const PrivacyPolicy = lazy(() => import("./pages/Privacy-Policy"));
const TermsConditions = lazy(() => import("./pages/Terms-conditions"));

function HomeHero() {
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;

    const reveal = () => {
      if (cancelled) return;
      const hero = document.getElementById("lcp-hero");
      const chrome = document.getElementById("boot-chrome");
      const copy = document.getElementById("boot-copy");
      if (hero) hero.hidden = pathname !== "/";
      if (chrome) chrome.hidden = true;
      if (copy) copy.hidden = true;
    };

    const sheet = document.querySelector('link[href*="/static/css/main"]');
    if (!sheet || sheet.rel === "stylesheet") {
      reveal();
      return () => {
        cancelled = true;
      };
    }

    window.addEventListener("nfg-css", reveal, { once: true });
    const timer = window.setTimeout(reveal, 3000);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      window.removeEventListener("nfg-css", reveal);
    };
  }, [pathname]);

  return null;
}

// function Home() { return <h1>Home Page</h1>; }
// function Contact() { return <h1>Contact Page</h1>; }
function About() {
  return (
    <>
      <PageMeta
        title="About"
        description="About Nafsika's Garden, a plant-based food brand making dairy-free cheeses and spreads for the whole family."
      />
      <h1>About Page</h1>
    </>
  );
}
// function Blog() { return <h1>Blog Page</h1>; }

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Nafsika's Garden",
  url: "https://nafsikasgarden.com/",
  logo: "https://nafsikasgarden.com/logo512.png",
};

function App() {
  return (
    <ToastProvider>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationJsonLd),
        }}
      />
      <Router>
        <HomeHero />
        <Header />

        <RouteLoading>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/store-locator" element={<StoreLocator />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/products/:handle" element={<ProductPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:handle" element={<SingleBlog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/our-impact" element={<Impact />} />
          <Route path="/our-story" element={<Story />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
        </RouteLoading>

        <Footer />
      </Router>
    </ToastProvider>
  );
}

export default App;
